import { mapState } from 'vuex';
import { get } from 'lodash';
export default {
  name: 'CoreDeviceTemplateKeyValueEditor',
  props: {
    header: {
      type: String,
      optional: false,
      default: ''
    },
    description: {
      type: String,
      optional: false,
      default: ''
    },
    keyLabel: {
      type: String,
      optional: false,
      default: ''
    },
    valueLabel: {
      type: String,
      optional: false,
      default: ''
    },
    deviceMeta: {
      type: Object,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    },
    property: {
      type: String,
      optional: false,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  watch: {
    deviceMeta() {
      this.initialMetaDataSetup();
    }
  },
  methods: {
    get,
    initialMetaDataSetup() {
      if (!this.deviceMeta[this.property]) {
        this.$set(this.deviceMeta, this.property, {
          '': {
            defaultValue: '',
            requiredValue: true
          }
        });
      }
    },
    keyValueKeyChanged(prior, newKey) {
      const trimmedKey = newKey.trim();
      if (prior === trimmedKey) {
        return;
      }
      const pairs = this.deviceMeta[this.property] || {};
      let uniqueKey = trimmedKey;
      let i = 0;
      while (pairs[uniqueKey] !== undefined && uniqueKey !== prior) {
        i++;
        uniqueKey = `${trimmedKey}${i}`;
      }
      const renamed = {};
      Object.keys(pairs).forEach(key => {
        renamed[key === prior ? uniqueKey : key] = pairs[key];
      });
      this.$set(this.deviceMeta, this.property, renamed);
    },
    addKeyValuePair() {
      if (!this.deviceMeta[this.property]) {
        this.$set(this.deviceMeta, this.property, {});
      }
      if (this.deviceMeta[this.property][''] === undefined) {
        this.$set(this.deviceMeta[this.property], '', {
          defaultValue: '',
          requiredValue: true
        });
      }
    },
    removeKeyValuePair(key) {
      const pairs = {
        ...(this.deviceMeta[this.property] || {})
      };
      delete pairs[key];
      this.$set(this.deviceMeta, this.property, pairs);
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    }
  }
};